import { toLocaleDateString } from "@/helpers/dateHelper";
import { PassengerDetailsResponse, PassengerResponse } from "../api/PassengerDetailsResponse";
import { PassengerTypeEnum } from "../enums";
import { Address } from "./Address";
import { PassengerState } from "./store/BookingState";

export class PassengerDetails {
	address: Address;
	passengers: Passenger[];

	constructor(resp: PassengerDetailsResponse) {
		this.address = new Address(resp.addressInformation);
		this.passengers = resp.bookedPassengers.map(p => new Passenger(p));
	}
}

export class Passenger implements PassengerState {
	id: number;
	type: PassengerTypeEnum;
	nameListId?: string;
	title?: string;
	firstName?: string;
	lastName?: string;
	postCode?: string;
	city?: string;
	dateOfBirth?: string;
	countryCode?: string;
	address?: string;
	mobilePhone?: string;
	concessionNumber?: string;
	validationRequired?: boolean;

	constructor(resp: PassengerResponse) {
		this.id = -1;
		this.type = resp.passengerType;
		this.nameListId = resp.nameListId;
		this.title = resp.title ? resp.title.charAt(0).toUpperCase() + resp.title.slice(1).toLowerCase() : "";
		this.firstName = resp.firstName;
		this.lastName = resp.lastName;
		this.postCode = resp.postCode;
		this.city = resp.city;
		this.dateOfBirth = resp.dateOfBirth ? toLocaleDateString(resp.dateOfBirth) : undefined;
		this.countryCode = resp.countryCode;
		this.address = resp.address;
		this.mobilePhone = resp.mobilePhone;
		this.concessionNumber = resp.concessionNumber;
		this.validationRequired = resp.validationRequired;
	}
}